import { render, staticRenderFns } from "./BoxCode2.vue?vue&type=template&id=61768fb2&scoped=true"
import script from "./BoxCode2.vue?vue&type=script&lang=js"
export * from "./BoxCode2.vue?vue&type=script&lang=js"
import style0 from "./BoxCode2.vue?vue&type=style&index=0&id=61768fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61768fb2",
  null
  
)

export default component.exports